/**
 * Route for `brand-color-logo-uploader`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { BrandColorLogoUploaderPage } from "../features/brand-color-logo-uploader/BrandColorLogoUploaderPage";

export const brandColorLogoUploaderRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/brand-color-logo-uploader",
	component: BrandColorLogoUploaderPage,
});

export default brandColorLogoUploaderRoute;
